import React from 'react';
import PropTypes from 'prop-types';
import { HorizontalFlex } from 'smartsuite-ui/lib/containers/HorizontalFlex';
import { PadContainer } from 'smartsuite-ui/lib/containers/PadContainer';
import { defaultViewKey } from '../shared/constants/constants';

export default function DashboardViewTitle(props) {
    if (!props.viewKey || props.viewKey === defaultViewKey) {
        return <span>{props.dashboardTitle}</span>;
    }

    return (
        <HorizontalFlex cssClassModifiers={['align-baseline']}>
            <span>{`${props.dashboardTitle}:`}</span>
            <PadContainer cssClassModifiers={['pad-small', 'no-pad-right']} />
            <span>{props.viewTitle}</span>
        </HorizontalFlex>
    );
}

DashboardViewTitle.propTypes = {
    dashboardTitle: PropTypes.string.isRequired,
    viewKey: PropTypes.string,
    viewTitle: PropTypes.string,
};
